




































































































import Vue from 'vue'
import HomeDashboardTile from '@/components/HomeDashboardTile.vue'
import HomeDashboardTileType from '@/types/components/HomeDashboardTile.interface'

interface ExploreCard {
    title: string
    subtitle: string
    selectedTitle?: string
    selectedSubtitle?: string
    text?: string
    icon: string
    color: string
    image: string
    video?: string
    goto?: GoToObject
}
interface GoToObject {
    text: string
    callback: Function
}
export default Vue.extend({
    components: { HomeDashboardTile },
    data: () => ({
        selectedCard: null,
        selectedType: null,
        step: 1
    }),
    computed: {
        broadcastCards(): ExploreCard[] {
            return [
                {
                    title: 'Broadcast',
                    subtitle: 'What Are Broadcasts?',
                    selectedTitle: 'How to Send a Broadcast',
                    selectedSubtitle:
                        'Learn how to reach 10s, 100s or 1,000s of contacts at once by sending a Broadcast.',
                    color: '#ECE8F8',
                    icon: 'bi-megaphone-fill',
                    image: this.$images.broadcastsWhat,
                    video: 'https://www.loom.com/embed/8b8d3e2e91964377ae047b39d072eae4?sid=a2c6b271-0727-4b70-bbbd-3e88d7d3b9ae',
                    goto: {
                        text: 'Go to Broadcast',
                        callback: () => this.goToBroadcasts()
                    }
                },
                {
                    title: 'Broadcast',
                    subtitle: 'Using Tags to Personalize Tags',
                    selectedTitle: 'Personalize Broadcasts Messages with Tags',
                    selectedSubtitle:
                        "Learn how to personalize each individual broadcast message so it's tailored to your contact.",
                    color: '#ECE8F8',
                    icon: 'bi-megaphone-fill',
                    image: this.$images.broadcastsTags,
                    video: 'https://www.loom.com/embed/977f21345a2b41639a2a3720f5bddcfc?sid=2e84baec-5ec0-410d-a798-568a9c886ef4',
                    goto: {
                        text: 'Go to Broadcast',
                        callback: () => this.goToBroadcasts()
                    }
                },
                {
                    title: 'Broadcast',
                    subtitle: 'How To Create Groups For Broadcast Messaging',
                    selectedTitle: 'Group Contacts to Easily Send Them a Broadcast ',
                    selectedSubtitle:
                        'Learn how to organize your contacts into unique groups for effective broadcast messaging.',
                    color: '#6142B0',
                    icon: 'bi-megaphone-fill',
                    image: this.$images.broadcastsGroup,
                    video: 'https://www.loom.com/embed/5d6a4aaf3dcd44eba96bad835dc40ea9?sid=41a9cd2e-06e0-4e9a-90e6-89f923494412',
                    goto: {
                        text: 'Go to Broadcast',
                        callback: () => this.goToBroadcasts()
                    }
                }
                // {
                //     title: 'Broadcast',
                //     subtitle: 'How To Run An SMS Keyword Campaign',
                // selectedTitle: "",
                // selectedSubtitle: "",
                //     color: '#FFC862',
                //     icon: 'bi-megaphone-fill',
                //     image: this.$images.broadcastsCampaign
                // }
            ]
        },
        conversationCards(): ExploreCard[] {
            //  ALL OF THESE IMAGES ARE TEMPORARY
            return [
                {
                    title: 'ChatBot',
                    subtitle: 'Text-Enable Your Website With A ChatBot',
                    selectedTitle: 'Start Conversations from Your Website with a Chatbot',
                    selectedSubtitle:
                        'Turn website visitors into SMS subscribers with the MessageDesk Chatbot',
                    color: '#FFDEA1',
                    icon: 'bi-chat-square-dots-fill',
                    image: this.$images.startConversationsChatbot,
                    video: 'https://www.loom.com/embed/242d44862ee34ecf8cf95f342fbb5e21?sid=70a7dff4-32bf-4e51-b7ac-2ff5bb3fefef',
                    goto: {
                        text: 'Go to Chatbot',
                        callback: () => this.goToChatbot()
                    }
                },
                {
                    title: 'Form',
                    subtitle: 'Use A Form To Collect Contact information',
                    selectedTitle: 'Use a MessageDesk Form to Collect SMS Subscribers',
                    selectedSubtitle:
                        'Create a simple form to collect contact information and grow your sms subscriber list in MessageDesk.',
                    color: '#FFDEA1',
                    icon: 'bi-person-fill',
                    image: this.$images.startConversationsForms,
                    video: 'https://www.loom.com/embed/eff75714901b424a94319c2b99b1b16d?sid=fd0b679a-02e0-48d1-8079-d16c95bb968b',
                    goto: {
                        text: 'Go to Forms',
                        callback: () => this.goToForms()
                    }
                },
                {
                    title: 'Autoresponder',
                    subtitle: 'Advertise Keywords At Your Place Of Business',
                    selectedTitle: 'Advertise Keywords to Start More Conversations',
                    selectedSubtitle:
                        'Effectively start conversations by advertising SMS keywords in your business.',
                    color: '#A08ED0',
                    icon: 'bi-lightning-charge-fill',
                    image: this.$images.startConversationsAutoresponders,
                    video: 'https://www.loom.com/embed/7ab71169318749fc8565bcc0eab5c1e2?sid=b101c176-c6cc-48db-b557-dfa50aa521bf',
                    goto: {
                        text: 'Go to Autoresponders',
                        callback: () => this.goToAutoresponders()
                    }
                }
            ]
        },
        exploreTiles(): HomeDashboardTileType[] {
            return [
                {
                    title: 'Inbox Mastery',
                    description:
                        'Master the Inbox with Templates, Scheduling, Folders, and Automations',
                    button: {
                        text: 'Explore the Inbox',
                        highlight: false,
                        callback: () => this.onTileSelected('inbox')
                    }
                },
                {
                    title: 'Reach 10s, 100s, or 1,000s at Once',
                    description:
                        'Setup MessageDesk for reaching multiple contacts at once',
                    button: {
                        text: 'Learn about Broadcasts',
                        highlight: false,
                        callback: () => this.onTileSelected('broadcasts')
                    }
                },
                {
                    title: 'Routing Conversations to a Team',
                    description:
                        'Unify your team into 1 inbox with effective conversation routing',
                    button: {
                        text: 'Learn about converastion routing',
                        highlight: false,
                        callback: () => this.onTileSelected('route')
                    }
                },
                {
                    title: 'Starting Conversations',
                    description: 'Learn how to fill the inbox with new messages',
                    button: {
                        text: 'Explore Chatbot, Forms, and Autoresponders',
                        highlight: false,
                        callback: () => this.onTileSelected('conversations')
                    }
                }
            ]
        },
        inboxCards(): ExploreCard[] {
            //  ALL OF THESE IMAGES ARE TEMPORARY
            return [
                {
                    title: 'Inbox',
                    subtitle: 'Send or Schedule 1-On-1 Text Messages',
                    selectedTitle: 'How to Send or Schedule a Message',
                    selectedSubtitle:
                        'Learn how to send your first text and schedule text message responses from the MessageDesk Inbox.',
                    color: '#FFC862',
                    icon: 'bi-inbox-fill',
                    image: this.$images.exploreInbox1on1,
                    video: 'https://www.loom.com/embed/15ddfb0241114d4bab52b62e7f3d0fef?sid=6cde4f08-4976-41af-a8d8-4afe16a70210',
                    goto: {
                        text: 'Go to Inbox',
                        callback: () => this.goToInbox()
                    }
                },
                {
                    title: 'Inbox',
                    subtitle: 'Reply Faster With Pre-Made Templates',
                    selectedTitle: 'Using Templates to Speed up Inbox Workflows',
                    selectedSubtitle:
                        'Learn how to use pre-saved message templates to respond faster to conversations in the Inbox',
                    color: '#A08ED0',
                    icon: 'bi-inbox-fill',
                    image: this.$images.exploreInboxTemplates,
                    video: 'https://www.loom.com/embed/596534b09deb42f8a7f77cafee71e218?sid=7a33a400-bcc4-40fc-b45c-f09e8b38c5a6',
                    goto: {
                        text: 'Go to Inbox',
                        callback: () => this.goToInbox()
                    }
                },
                {
                    title: 'Inbox',
                    subtitle: 'Open Vs. Closed Messages',
                    selectedTitle: 'Understanding Open and Closed Conversations',
                    selectedSubtitle:
                        'Learn how to keep a tidy inbox by closing conversations and effectively managing your open conversations.',
                    color: '#FFC862',
                    icon: 'bi-lightning-charge-fill',
                    image: this.$images.exploreInboxOpenClose,
                    video: 'https://www.loom.com/embed/f52c00ee6d8e413d8cfe8ce01439f57e?sid=13b7072b-cac1-49aa-bd0a-db09df96b1cf',
                    goto: {
                        text: 'Go to Inbox',
                        callback: () => this.goToInbox()
                    }
                },
                {
                    title: 'Inbox',
                    subtitle: 'What Are Message Statuses?',
                    selectedTitle: 'Message Status Explained',
                    selectedSubtitle:
                        'Learn about the difference between New, Waiting, and Replied messages in the Inbox',
                    color: '#FFDEA1',
                    icon: 'bi-inbox-fill',
                    image: this.$images.exploreInboxStatus,
                    video: 'https://www.loom.com/embed/bf515e9bd19b4347a697f4363dbe6971?sid=b66f4e01-9c2a-484c-9a60-346c00543bb0',
                    goto: {
                        text: 'Go to Inbox',
                        callback: () => this.goToInbox()
                    }
                },
                {
                    title: 'Inbox',
                    subtitle: 'Find The Right Message Every Time With Inbox Filtering',
                    selectedTitle: 'Using Inbox Filters to Find the Right Conversation',
                    selectedSubtitle:
                        "Use inbox filters to find the right message every time. Simply click the filter icon and select what type of conversations you're looking for.",
                    color: '#FFC862',
                    icon: 'bi-inbox-fill',
                    image: this.$images.exploreInboxFilter,
                    video: 'https://www.loom.com/embed/277a2f57d00e42c09209d5c7f64d295b?sid=a0a39d77-c3dc-4a07-9dc8-d5d97939659a',
                    goto: {
                        text: 'Go to Inbox',
                        callback: () => this.goToInbox()
                    }
                }
            ]
        },
        routeCards(): ExploreCard[] {
            //  ALL OF THESE IMAGES ARE TEMPORARY
            return [
                {
                    title: 'Inbox',
                    subtitle: 'Manually Assign Conversations To Teammates',
                    selectedTitle: 'How to Assign Conversations to Teammates',
                    selectedSubtitle:
                        'Effectively route conversations across your entire team with conversation assignment.',
                    color: '#FFC862',
                    icon: 'bi-inbox-fill',
                    image: this.$images.routeConversationsManualAssign,
                    video: 'https://www.loom.com/embed/dde9d0bdd5364e94ac6222d5cf9decf1?sid=a19a5479-92af-4a79-a93e-cbaa4e6d02f5',
                    goto: {
                        text: 'Go to Team',
                        callback: () => this.goToTeam()
                    }
                },
                // {
                //     title: 'Inbox',
                //     subtitle: 'Automatically Assign Conversations To Teammates',
                //     selectedTitle:
                //         'Automatically Route Conversations based on Keyword Reply',
                //     selectedSubtitle:
                //         'Automatically route and respond to conversations based on the message received.',
                //     color: '#F8F5F2',
                //     icon: 'bi-inbox-fill',
                //     image: this.$images.routeConversationsAutoAssign,
                //     video: '',
                //     goto: {
                //         text: 'Go to Team',
                //         callback: () => this.goToTeam()
                //     }
                // }
                {
                    title: 'Autoresponder',
                    subtitle: 'Automatically Route Conversations Based On Keyword Reply',
                    selectedTitle:
                        'Automatically Route Conversations to Teammates When They Reply',
                    selectedSubtitle:
                        'Automatically route and respond to conversations based on the message received.',
                    color: '#FFC862',
                    icon: 'bi-lightning-charge-fill',
                    image: this.$images.routeConversationsAutoRoute,
                    video: 'https://www.loom.com/embed/ae5db57842aa4ebca01bf0b60855f12f?sid=4219bd6d-f7c3-44d6-9969-224f7a6bdd66',
                    goto: {
                        text: 'Go to Team',
                        callback: () => this.goToTeam()
                    }
                }
            ]
        },
        selectedCards(): ExploreCard[] {
            //  Grab our selected type
            const type = this.selectedType

            //  If a type hasn't been selected, return null
            if (!type) return null

            //  Return a different type of card based on the type
            return {
                broadcasts: this.broadcastCards,
                conversations: this.conversationCards,
                inbox: this.inboxCards,
                route: this.routeCards
            }[type]
        },
        title(): string {
            //  Grab our selected type
            const type = this.selectedType

            //  If a type hasn't been selected, return null
            if (!type) return null

            //  Return a different title based on type
            return {
                broadcasts:
                    'Reach Multiple Contacts at Once with Private 1-on-1 Messages',
                conversations: 'Start Conversations Consistently and Easily',
                inbox: 'Inbox Mastery',
                route: 'Route Conversations Across Your Team'
            }[type]
        }
    },
    methods: {
        goToAutoresponders(): void {
            //  Route to autoresponders
            this.$router.push('/auto-responders')

            //  Close our dialog
            this.$emit('close')
        },
        goToBroadcasts(): void {
            //  Route to broadcasts
            this.$router.push('/broadcasts')

            //  Close our dialog
            this.$emit('close')
        },
        goToChatbot(): void {
            //  Route to chatbots
            this.$router.push('/chatbots')

            //  Close our dialog
            this.$emit('close')
        },
        goToForms(): void {
            //  Route to forms
            this.$router.push('/forms')

            //  Close our dialog
            this.$emit('close')
        },
        goToInbox(): void {
            //  Route to inbox
            this.$router.push('/inbox')

            //  Close our dialog
            this.$emit('close')
        },
        goToTeam(): void {
            //  Route to teammates
            this.$router.push('/teammates')

            //  Close our dialog
            this.$emit('close')
        },
        onCardSelected(card: ExploreCard): void {
            //  Set our selected card
            this.selectedCard = card

            //  Go to our next step
            this.step = 3
        },
        onTileSelected(type: string): void {
            //  Set our type to whatever type was clicked
            this.selectedType = type

            //  Go to step 2
            this.step = 2
        },
        popTour(): void {
            console.log('TODO IMPLEMENT TOUR')
        }
    }
})
